module.exports = __webpack_public_path__ + "static/media/home-slide.198784a0.png";